/**
 * Template "Kleuren opvragen" (melding Pieter 479cb856, tekst akkoord Tom
 * 01-10-2026): de klant vragen om de kleurcodes of een oud verfblik, met als
 * alternatief dat wij komen meten. Eén tekst voor WhatsApp (Meta-template met
 * {{1}} naam en {{2}} adres) en e-mail (email_templates, type
 * 'kleuren_opvragen', met {{contactnaam}} en {{adres}}).
 *
 * De tekst is letterlijk Toms akkoord; verander hem niet zonder nieuw akkoord.
 * Een gewijzigde WhatsApp-tekst betekent bovendien een nieuwe template bij Meta.
 */
export const KLEUREN_OPVRAGEN_NAAM = 'kleuren_opvragen';

const ALINEAS = [
  'Voor het schilderwerk aan {{adres}} hebben wij nog geen definitieve kleurcodes genoteerd. Om verwarring en fouten te voorkomen ontvangen wij die graag van u, zodat we ze samen kunnen vastleggen.',
  'Heeft u de kleurcodes (bijvoorbeeld een RAL- of Sigma-code) of een oud verfblik? Stuur ze dan via dit bericht, eventueel met een foto van het blik. Wij zetten ze in de offerte en vragen u daarna om akkoord op de kleuren.',
  'Heeft u geen codes? Dan komen wij langs om de kleuren te meten met de kleurenwaaier en de kleurscanner. Laat ons weten welk moment u schikt.',
  'Met vriendelijke groet,\nTeam Pracht Totaalonderhoud',
];

/** Tekst met benoemde velden ({{naam}}, {{adres}}) zoals de app hem invult. */
export const KLEUREN_OPVRAGEN_TEKST = ['Beste {{naam}},', ...ALINEAS].join('\n\n');

/** Dezelfde tekst met genummerde velden, zoals Meta hem wil: {{1}} naam, {{2}} adres. */
export const KLEUREN_OPVRAGEN_META_BODY = KLEUREN_OPVRAGEN_TEKST.replace(
  '{{naam}}',
  '{{1}}',
).replace('{{adres}}', '{{2}}');

/** Voorbeeldwaarden voor de beoordeling door Meta (één per veld). */
export const KLEUREN_OPVRAGEN_VOORBEELD = ['mevrouw De Vries', 'Kerkstraat 12 in Alkmaar'];

export const KLEUREN_OPVRAGEN_EMAIL_ONDERWERP = 'Kleuren voor het schilderwerk aan {{adres}}';

export interface KleurenOpvragenVelden {
  naam: string;
  adres: string;
}

/** Vult de velden in; een leeg veld wordt een lege plek, niet "undefined". */
export function vulKleurenOpvragen(
  v: KleurenOpvragenVelden,
  tekst = KLEUREN_OPVRAGEN_TEKST,
): string {
  return tekst
    .replace(/\{\{naam\}\}/g, v.naam.trim())
    .replace(/\{\{contactnaam\}\}/g, v.naam.trim())
    .replace(/\{\{adres\}\}/g, v.adres.trim());
}

const VVE_REGEX = /(^|[^a-z])v\.?v\.?e\.?($|[^a-z])/i;

/** Of een naam/bedrijf/bron op een Vereniging van Eigenaren wijst. */
export function isVvE(i: {
  naam?: string | null;
  bedrijf?: string | null;
  bron?: string | null;
}): boolean {
  if ((i.bron ?? '').trim().toLowerCase() === 'vve') return true;
  return VVE_REGEX.test(i.bedrijf ?? '') || VVE_REGEX.test(i.naam ?? '');
}

/**
 * De aanhefnaam voor "Beste …": de contactpersoon, of bij een VvE "bestuur van
 * VvE <naam>" (besluit Tom 01-10). Als de VvE-naam zelf al met "VvE" begint,
 * verdubbelen we dat niet.
 */
export function kleurenAanhefNaam(i: {
  contactNaam?: string | null;
  bedrijf?: string | null;
  bron?: string | null;
}): string {
  const contact = (i.contactNaam ?? '').trim();
  const bedrijf = (i.bedrijf ?? '').trim();
  if (!isVvE({ naam: contact, bedrijf, bron: i.bron })) return contact || bedrijf;

  const vveNaam = (
    VVE_REGEX.test(bedrijf) ? bedrijf : VVE_REGEX.test(contact) ? contact : bedrijf || contact
  )
    .replace(/^\s*v\.?v\.?e\.?\s*/i, '')
    .trim();
  return vveNaam ? `bestuur van VvE ${vveNaam}` : 'bestuur van de VvE';
}
